export const SortingType = {
    "NAME": "NAME",
    "SIZE": "SIZE",
    "MODIFIED": "MODIFIED",
    "IMPORTED": "IMPORTED",
    "CONTEXT": "CONTEXT"
};
